import { AuthenticationFailed, LayoutType, ReservationOrigin, SubscriptionBillingInterval } from 'gleblu-socket-api';

import { SubscriptionState } from '@/models/interfaces/Subscriptions';

import ReservationRejectReason from '../../models/interfaces/reservation/ReservationRejectReason';
import Translation from './Translation';

const hungarianTranslation: Translation = {
  menuCategories: 'Menükategóriák',
  hidden: 'Rejtett',
  categories: 'Kategóriák',
  accountingHeader: 'Könyvelés',
  aboutSlogen: 'Kezeld a foglalásaid egyetlen helyről',
  aboutWhatWeDo: 'Mivel foglalkozunk',
  aboutWhatWeDoText:
    'A Gleblu egy online foglalási platform. Egyezteti az asztalokat kereső embereket éttermekkel. A gleblu.ro webhelyen megtalálhat egy megfelelő helyet, ' +
    'másodpercek alatt lefoglalhat egy táblát, és azonnal megkaphatja visszaigazolás a foglalásról.Ellenőrizze az órákat vagy a kedvenc étterme menüjét, ' +
    'vagy felfedezni új helyeket.',
  aboutUs: 'Ez a Gleblu',
  aboutUsText:
    'A Gleblu egy fiatal társaság. Gleblu mögött egy kis szoftverfejlesztõ csapat található. Szupererőnk az, hogy nagyon motiváltak vagyunk. ' +
    'Ismerje meg az alapítókat.',
  aboutZsolt:
    'Zsolt a Gleblu vezérigazgatója, technológiai vállalkozó, több mint 3 éves tapasztalattal rendelkezik az indulási és szoftverfejlesztési területeken. ' +
    'Számítástechnikusi diplomát szerzett az ETH Zürichben.',
  aboutZsoltJob: 'Az operations sensei',
  aboutIstvan:
    'István a Gleblu műszaki vezetője, több mint 6 éves szoftverfejlesztési tapasztalattal rendelkező szoftvermérnök. Ő vezeti szolgáltatásunk fejlesztését. ' +
    'Információs mérnöki diplomát szerzett a kolozsvári Babeș-Bolyai Egyetemen.',
  aboutIstvanJob: 'A hacker',
  aboutFindOutMore: 'Tudjon meg többet',
  aboutHeaderInfo: 'Rólunk',
  contactHeader: 'Kapcsolatok',
  contactMassMedia: 'Ön a média része?',
  contactMassMediaText: 'Szeretne írni Gleblu-ról? Szüksége van képekre, logókra vagy interjúkra? Nyugodtan írjon nekünk:',
  contactUs: 'Írjon nekünk a következő címen:',
  contactRestaurant: 'Ön étteremtulajdonos?',
  contactRestaurantText:
    'Kezelje foglalásait több forrásból (például webhelye, Facebook oldala, Facebook Messenger, gleblu.ro) egy helyen! ' +
    'Te és az a személyzet bármilyen számítógépről, telefonról vagy táblagépről ellenőrizheti ezeket a foglalásokat. Elfogadhatja vagy elutasíthatja ' +
    'fenntartások a várólistán, vagy hagyja, hogy Gleblu végezze el a munkát, és automatizálja ezt a folyamatot, hogy időt takarítson meg te. ' +
    'Ha összekapcsolja Facebook oldalát a Gleblu chatbotjával, akkor válaszol a vendégeire Messenger, adjon információt a helyéről és foglaljon helyet. ' +
    'Próbálja ki ingyen:',
  contactRelations: 'Ügyfélkapcsolatok',
  reset: 'Visszaállítás',
  guestbook: 'Vendégkönyv',
  firstName: 'Keresztnév',
  lastName: 'Családnév',
  email: 'Email',
  passwordLabel: 'Jelszó',
  initialPasswordLabel: 'Kezdeti jelszó',
  errorPageMessage: 'Sajnáljuk, hiba történt.',
  errorPageAction: 'Kezdőlap',
  signupMessage: ['Még nincs fiókod?', 'Regisztrálj most!'],
  currentTime: 'Mai nap',
  jumpCurrentTime: 'Ugrás a mai naphoz',
  cancelReservationAction: 'Foglalás törlése',
  notifyGuest: 'Értesítened kell a vendéget mielőtt törlöd a foglalást!',
  numberOfGuests: 'Vendégek',
  table: 'Asztalok',
  nameLabel: 'Név',
  phoneNumber: 'Telefonszám',
  enterPhoneNumber: 'Add meg a telefonszámod',
  emailAddress: 'Email',
  specialRequest: 'Megjegyzés',
  editAction: 'Szerkesztés',
  editGuestAction: 'Vendég szerkesztése',
  noTablesSelected: 'Nincs asztal kiválasztva',
  reservationDateInThePast: 'Foglalás dátuma a múltban',
  cancelAction: 'Mégse',
  saveAction: 'Mentés',
  editReservationAction: 'Foglalás szerkesztése',
  newReservationAction: 'Új foglalás',
  reservationDetails: 'Foglalás részletei',
  reservationManagementPageTitle: 'Foglaláskezelés',
  tableStateFree: 'Szabad',
  tableStatePrepare: 'Előkészít',
  tableStateReserved: 'Foglalt',
  tableStateReady: 'Kész',
  tableStateSeated: 'Leült',
  missingPageApology: 'Sajnálom, de a keresett oldal nem található.',
  missingPageExplanations: 'Lehetséges, hogy ez a funkció még nem készült el.',
  name: 'Név',
  address: 'Cím',
  hoursOfOperation: 'Nyitva tartás',
  website: 'Weboldal',
  menu: 'Étlap',
  websiteInputPlaceholder: 'Add meg a weboldalad linkjét',
  menuInputPlaceholder: 'Add meg az étlapod linkjét',
  pictures: 'Képek',
  description: 'Leírás',
  descriptionPlaceHolder: 'Írd le a vendéglátóhelyedet',
  contact: 'Elérhetőségek',
  accountMenuItemText: 'Fiók',
  generalSettingsMenuItemText: 'Általános',
  hoursSettingsMenuItemText: 'Nyitva tartás',
  picturesSettingsMenuItemText: 'Képek',
  reservationSettingsMenuItemText: 'Foglalás',
  layoutSettingsMenuItemText: 'Terem',
  settings: 'Beállítások',
  websiteForGuestsLink: 'Gleblu',
  aboutLink: 'Névjegy',
  termsAndConditionsLink: 'Felhasználási feltételek',
  privacyLink: 'Adatvédelmi szabályzat',
  sendAction: 'Küldés',
  sendFeedbackCallToAction: 'Küldj visszajelzést',
  sendFeedbackDialogTitle: 'Küldj nekünk visszajelzést',
  sendFeedbackDialogDescription: 'Kérlek, töltsd ki az alábbi üzenetmezőt:',
  reservationManagementMenuText: 'Foglaláskezelés',
  settingsPageManagementMenuText: 'Beállítások',
  guestsAnalyticsPageManagementMenuText: 'Statisztika a vendégekről',
  reservationsAnalyticsPageManagementMenuText: 'Foglalások statisztikái',
  guestsFrequency: 'Vendégek bejelentkezésének gyakorisága: ',
  firstTimeVisits: 'Első látogatások:',
  frequentVsFirstTime: 'Gyakori vendégek és első látogatások összehasonlítása',
  averageResponseTime: 'Átlagos válaszidő a függőben lévő foglalásokra:',
  pastReservationsNr: 'Korábbi foglalások száma:',
  upcomingReservationsNr: 'Bejövő foglalások száma:',
  pendingReservationsMenuText: 'Várólista',
  conflictingReservationsMenuText: 'Hibák megoldása',
  languageMenuText: 'Nyelv',
  addNewPlaceMenuText: 'Új vendéglátóhely',
  signOutMenuText: 'Kijelentkezés',
  required: 'Kötelező',
  mustBeNumeric: 'Érvénytelen szám',
  mustBeUrl: 'Érvénytelen webcím',
  mustBePhoneNumber: 'Érvénytelen telefonszám',
  mustBeEmailAddress: 'Érvénytelen email cím',
  maximumAllowedValue: (maxValue: number) => `Maximális érték ${maxValue}`,
  minimumAllowedValue: (minValue: number) => `Minimális érték ${minValue}`,
  alreadyAdded: 'Már hozzáadva',
  maximumNumberOfGuestsSettingLabel: 'Vendégek száma',
  maximumNumberOfGuestsSentenceStart: 'Engedélyezz maximum',
  maximumNumberOfGuestsSentenceEnd: 'foglalásonként.',
  maximumNumberOfReservationsSettingLabel: 'Foglalások száma',
  maximumNumberOfReservationsSentenceStart: 'Engedélyezz maximum',
  maximumNumberOfReservationsSentenceEnd: 'egyidejűleg.',
  durationSettingLabel: 'Időtartam',
  durationSmallGroupSentenceStart: 'Foglalás hossza',
  durationSmallGroupSentenceEnd: '2 vendég esetén.',
  durationMediumGroupSentenceStart: 'Foglalás hossza',
  durationMediumGroupSentenceEnd: '3-6 vendég esetén.',
  durationLargeGroupSentenceStart: 'Foglalás hossza',
  durationLargeGroupSentenceEnd: '7+ vendég esetén.',
  waitingTimeSettingLabel: 'Türelmi idő',
  waitingTimeSettingSentenceStart: 'A foglalás lemondása, ha a vendég késik',
  minimumLeadTimeSettingLabel: 'Minimum átfutási idő',
  minimumLeadTimeSettingSentenceStart: 'A vendég minimum',
  minimumLeadTimeSettingSentenceEnd: 'előre foglalhat asztalt.',
  maximumLeadTimeSettingLabel: 'Maximális átfutási idő',
  maximumLeadTimeSettingSentenceStart: 'A vendég maximum',
  maximumLeadTimeSettingSentenceEnd: 'előre foglalhat asztalt.',
  preReserveSettingLabel: 'Elő-foglalás',
  preReserveSettingSentenceStart: 'Az asztal előkészítése',
  preReserveSettingSentenceEnd: 'a foglalás kezdete előtt.',
  minuteSingular: 'percet',
  minutePlural: 'percet',
  minutePreReserveSingular: 'perccel',
  minutePreReservePlural: 'perccel',
  hourSingular: 'órával',
  hourPlural: 'órával',
  hourDurationSingular: 'óra',
  hourDurationPlural: 'óra',
  daySingular: 'napra',
  dayPlural: 'napra',
  reservationSingular: 'foglalást',
  reservationPlural: 'foglalást',
  guestSingular: 'vendéget',
  guestPlural: 'vendéget',
  guests: (_: number) => 'vendég',
  open: 'nyitva',
  closed: 'zárva',
  mapView: 'Térképnézet',
  scheduleView: 'Ütemterv nézet',
  switchToCurrentTime: 'Ugrás a mai naphoz',
  turnCurrentTimeOff: 'Kikapcsolás',
  opensEarlierThanClosesErrorMessage: 'Korábban nyit, mint az előző napi zárás',
  closesLaterThanOpensErrorMessage: 'Később zár, mint a következő napi nyitás',
  closedOnThisDate: 'Zárva van ebben az időpontban.',
  closedOnThisDay: 'Zárva van ezen a napon.',
  noTableSuggestion: 'Nincs javaslat',
  suggestedTable: 'Javaslat',
  accept: 'Elfogad',
  reject: 'Visszautasít',
  changePlan: 'Előfizetés módosítása',
  change: 'Módosítás',
  resolveAction: 'Megoldás',
  autoResolveAction: 'Automatikus megoldás',
  timeCaption: 'Időpont',
  vatNumberLabel: 'Adószám',
  emailAddressPlaceholder: 'példa@email.com',
  newPasswordLabel: 'Új jelszó',
  confirmPasswordLabel: 'Jelszó megerősítése',
  passwordTooShort: 'Jelszó túl rövid',
  passwordsDoNotMatch: 'Jelszavak nem egyeznek',
  weakPasswordNoNumber: 'Gyenge jelszó: tartalmaznia kell számot',
  weakPasswordNoUppercase: 'Gyenge jelszó: tartalmaznia kell nagybetűt',
  weakPasswordNoLowercase: 'Gyenge jelszó: tartalmaznia kell kisbetűt',
  login: 'Bejelentkezés',
  contactPerson: 'Kapcsolattartó személy',
  company: 'Cég',
  companyName: 'Cég neve',
  register: 'Regisztráció',
  inProgress: 'Folyamatban',
  completed: 'Befejezve',
  retry: 'Újra',
  registrationSuccessful: 'Sikeres regisztráció',
  registrationFailed: 'Sikertelen regisztráció',
  checkConfirmationEmail: 'Kérlek, ellenőrizd az email fiókod a visszaigazoló emailért.',
  retryLater: 'Kérlek, próbáld újra később',
  emailVerificationFailed: 'Email megerősítés sikertelen',
  errorOccurred: 'Hiba történt',
  tokenInvalidOrExpired: 'Token érvénytelen vagy lejárt',
  resendToken: 'Token újraküldése',
  missingToken: 'Token hiányzik',
  emailVerified: 'Email megerősítve',
  minimumCharacters: (value: number) => `Minimum ${value} karakter`,
  submit: 'Küldés',
  placeNameLabel: 'Vendéglátóhely neve',
  placeNamePlaceholder: 'Írd be a vendéglátóhely nevét',
  streetLabel: 'Utca',
  streetPlaceholder: 'Írd be az utca nevét',
  houseNumber: 'Házszám',
  houseNumberPlaceholder: 'Írd be a házszámot',
  cityLabel: 'Város',
  cityPlaceholder: 'Írd be a város nevét',
  countryLabel: 'Ország',
  countryPlaceholder: 'Írd be az ország nevét',
  didYouMean: 'Erre gondoltál',
  selectAction: 'Válaszd ki',
  contributors: 'Közreműködők',
  placeSetupPageTitle: 'Add meg a vendéglátóhelyed adatait',
  reservationLayoutTypeLabel: 'Bent vagy teraszon',
  addAction: 'Hozzáad',
  modifyAction: 'Modosít',
  tableLabelLabel: 'Címke',
  tableCapacityLabel: 'Férőhely',
  tableLabelPlaceholder: 'Írd be a címkét',
  tableCapacityPlaceholder: 'Férőhelyek száma',
  labelAlreadyTaken: 'Ez a címke már foglalt',
  tables: 'Asztalok',
  leavePageDialogTitle: 'Oldal elhagyása',
  leavePageDialogContent: 'A változtatások el fognak vesztődni.',
  leavePageDialogConfirmAction: 'Oldal elhagyása',
  reloadTitle: 'Újratöltés',
  reloadContent: 'Az adatokat valaki más megváltoztatta. A folytatáshoz töltse be újra az oldalt.',
  reloadAction: 'Újratöltés',
  addNewReservation: 'Új foglalás létrehozása',
  takeSuggestionAction: 'Kiválaszt',
  latitudeLabel: 'Szélességi kör',
  longitudeLabel: 'Hosszúsági kör',
  activationSuccessful: 'Sikeres aktiválás',
  activationFailed: 'Sikertelen aktiválás',
  enableReservationsSuccessful: 'Sikeresen engedélyeztük a foglalásokat',
  enableReservationsDescription: 'E-maillben értesítjük amikor a vendégek foglalnak a Gleblu alkalmazásban',
  enableReservationsFailed: 'Foglalások engedélyezése sikertelen',
  disableReservationsSuccessful: 'Sikeresen letiltottuk a foglalásokat',
  disableReservationsDescription: 'A vendégek nem foglalhatnak a Gleblu alkalmazásban',
  disableReservationsFailed: 'Foglalások letiltása sikertelen',
  enableGuestWebSuccessful: 'Sikeres hozzáadás',
  enableGuestWebDescription: 'Ismét hozzáadtuk a vendéglátóhelyet a Gleblu alkalmazáshoz, a vendégek látni fogják',
  enableGuestWebFailed: 'Sikertelen hozzáadás',
  disableGuestWebSuccessful: 'Sikeres eltávolítás',
  disableGuestWebDescription: 'Eltávolítottuk a vendéglátóhelyet a Gleblu alkalmazásból, a vendégek többé nem fogják látni',
  disableGuestWebFailed: 'Sikertelen eltávolítás',
  placeLabel: 'Vendéglátóhely',
  googlePlaceId: 'Google place id',
  facebookPageToken: 'Facebook page token',
  facebookPageId: 'Facebook page id',
  and: 'és',
  acceptTerm: (button: string) => `A "${button}" gombra kattintva elfogadod a következőket:`,
  automatic: 'Automatikus',
  outsideHours: 'A foglalás a nyitvatartási időn kívül esik',
  durationTooHigh: 'Időtartam hosszabb, mint az alapértelmezett',
  durationTooLow: 'Időtartam rövidebb, mint az alapértelmezett',
  tableNotAvailable: 'Néhány asztal nem elérhető',
  capacityTooHigh: 'Férőhelyek száma túl magas',
  capacityTooLow: 'Férőhelyek száma túl alacsony',
  deleteAction: 'Törlés',
  layoutTypesTitle: {
    [LayoutType.indoor]: 'Bent',
    [LayoutType.outdoor]: 'Terasz',
  },
  loginFailed: {
    [AuthenticationFailed.invalidEmailOrPassword]: 'Sikertelen bejelentkezés',
    [AuthenticationFailed.notActivated]: 'Email cím nincs visszaigazolva',
  },
  totalCapacity: 'Összes férőhely',
  timeInterval: 'Asztalok foglalva',
  reservationDateLabel: 'Foglalás dátuma',
  pageNotFoundTitle: 'Az oldal nem található',
  placeNotFoundTitle: 'A hely nem található',
  placeNotFoundReason: 'A hely nem létezik.',
  facebookLogin: 'Jelentkezz be és válaszd ki a Facebook oldalad!',
  selectedFacebookPage: 'A kiválasztott oldal:',
  facebookPages: 'Facebook oldalak',
  resetStepper: 'Visszaállítás',
  stepperBack: 'Vissza',
  unknownStep: 'Ismeretlen lépés',
  firstStep: 'Jelentkezz be Facebookal',
  secondStep: 'Válasszd ki a Facebook oldalt',
  thirdStep: 'Iratkozz fel a Chatbotra',
  chatbotSettingsMenuItem: 'Chatbot',
  automaticReservationMenuItem: 'Automatikus foglalás',
  automaticReservationDescription: 'A Gleblu automatikusan el tudja fogadni a foglalásokat és hozzá tudja rendelni azokat a megfelelő asztalokhoz.',
  tableNotInLayoutType: {
    [LayoutType.indoor]: 'Néhány asztal nincs bent',
    [LayoutType.outdoor]: 'Néhány asztal nincs a teraszon',
  },
  phoneNumberNotSet: 'A telefonszám nincs megadva',
  guestWebEnabledLabel: 'Láthatóság',
  guestWebEnabledSwitch: { true: 'Vendégeknek látható', false: 'Vendégeknek nem látható' },
  acceptsReservationsLabel: 'Foglalás',
  acceptsReservationsSwitch: { true: 'Engedélyezve', false: 'Kikapcsolva' },
  autoAcceptReservationLabel: 'Automatikus elfogadás',
  autoAcceptReservation: { true: 'Automatikus', false: 'Nem automatikus' },
  guestsArrived: 'Vendégek megérkeztek',
  errors: {
    wrongPassword: 'Hibás jelszó.',
    emailAddressNotFound: 'Az email cím nem található.',
    invalidToken: 'A token érvénytelen.',
    expiredToken: 'A token lejárt.',
    operationAlreadyCompleted: 'A művelet már befejeződött.',
    placeDisabled: '',
  },
  forgotPasswordLink: 'Elfelejtett jelszó?',
  passwordResetLinkSendingError: 'Nem sikerült elküldeni a jelszó-visszaállítási linket!',
  passwordResetLinkSentSuccessfully: 'A jelszó-visszaállítási link elküldve. Ellenőrizd az email fiókod.',
  passwordResetFailed: 'Nem sikerült megváltoztatni a jelszót',
  passwordResetSuccessful: 'A jelszó megváltoztatva. Bejelentkezhetsz az új jelszóval.',
  passwordChangeFailed: 'Nem sikerült megváltoztatni a jelszót',
  noSpecialHours: 'Nincs rendkívüli nyitva tartás',
  date: 'Dátum',
  hoursTableHeader: 'Nyitva tartás',
  specialHourDateAlreadyAdded: 'Erre a dátumra már hozzáadtál rendkívüli nyitva tartást',
  announcements: {
    ReservationCreated: 'Foglalás létrehozva',
    ReservationCreationFailed: 'Nem sikerült létrehozni a foglalást. Kérlek, próbáld újra később.',
    ReservationOutsideHours: 'Nem sikerült létrehozni a foglalást, a nyitvatartási időn kívül esik.',
    ReservationUpdated: 'Foglalás frissítve',
    ReservationUpdateFailed: 'Nem sikerült frissíteni a foglalást. Kérlek, próbáld újra később.',
    ReservationCanceled: 'Foglalás törölve',
    ReservationCancelFailed: 'Nem sikerült törölni a foglalást. Kérlek, próbáld újra később.',
    ReservationStateUpdated: 'Foglalás állapota frissítve',
    ReservationStateUpdateFailed: 'Nem sikerült frissíteni a foglalási állapotot. Kérlek, próbáld újra később.',
    FeedbackReceived: 'Visszajelzés elküldve. Köszönjük!',
    FeedbackFailed: 'Nem sikerült elküldeni a visszajelzést. Kérlek, próbáld újra később.',
    ContactSaved: 'Általános beállítások elmentve',
    ReservationSettingSaved: 'Foglalás beállítások elmentve.',
    ProfileSaved: 'Képek elmentve',
    LayoutSaved: 'Asztalok elmentve',
    EmployeeUpdated: 'Alkalmazott endedélyei elmentve',
    EmployeeUpdateFailed: 'Nem sikerült elmenteni az alkalmazott engedélyeit',
  },
  employees: 'Alkalmazottak',
  permissions: 'Engedélyek',
  assignedTables: 'Hozzárendelt táblák',
  workingSchedule: 'Munkabeosztás',
  permissionLevels: { unauthorized: 'Jogosulatlan', view: 'Megtekintés', edit: 'Szerkesztés' },
  reservationPermission: 'Foglalás engedély',
  settingPermission: 'Beállítások engedély',
  emptyDataSourceMessage: 'Nincsenek megjeleníthető rekordok',
  filterTooltip: 'Szűrő',
  rowDeleteConfirmation: 'Biztosan törlöd ezt a sort?',
  actionsTooltip: 'Műveletek',
  groupedBy: 'Csoportosítva',
  dragHeaders: 'Húzd a fejléceket',
  firstPage: 'Első oldal',
  previousPage: 'Előző oldal',
  nextPage: 'Következő oldal',
  lastPage: 'Utolsó oldal',
  displayedRowsLabel: '{from}-{to}: {count}',
  rowsPerPageLabel: 'Sorok oldalanként',
  rowsLabel: 'Sor',
  addOrRemoveColumns: 'Oszlopok hozzáadása vagy eltávolítása',
  showColumns: 'Oszlopok megjelenítése',
  exportTooltip: 'Export',
  exportAsCsv: 'Exportálás CSV',
  searchTooltip: 'Keresés',
  deletePermissionRowConfirmation: 'Biztosan törlöd ezt az engedélyt?',
  noProfileImage: 'Nincs profilkép',
  uploadTakesTime: 'Kérlek, légy türelemmel. A feltöltés eltarthat egy ideig.',
  employeesToBeInvited: 'Meghívandó alkalmazottak',
  alreadyInvited: 'Már meghívva',
  emailTextAreaPlaceholder: 'Írd be vagy illeszd be az email címeket és nyomd meg az "Enter" gombot',
  extractEmails: 'Emailek hozzáadása',
  noEmailsFoundInInput: 'Nem található email',
  inviteEmployeesSubmitError: 'Nem sikerült meghívni az alkalmazottakat',
  originTitle: {
    [ReservationOrigin.chatbot]: 'Facebook Messenger',
    [ReservationOrigin.facebookTab]: 'Facebook Tab',
    [ReservationOrigin.guestWeb]: 'Gleblu.ro',
    [ReservationOrigin.guestApp]: 'Gleblu App',
    [ReservationOrigin.placeWeb]: 'Gleblu Business',
    [ReservationOrigin.webWidget]: 'Web widget',
    [ReservationOrigin.authenticatedGuestWeb]: 'Igazolt Gleblu.ro',
  },
  unauthorizedToViewReservations: 'Nincs jogosultságod megnézni a foglalásokat',
  unauthorizedToViewPlaceSettings: 'Nincs jogosultságod megnézni a hely beállításait',
  unauthorizedToViewCompanySettings: 'Nincs jogosultságod megnézni a cég beállításait',
  unauthorizedToAddPlaces: 'Nincs jogosultságod új helyet létrehozni',
  unauthorizedToViewPlace: 'Nincs jogosultságod a hely elérésére',
  createdBy: 'Készítette',
  updatedBy: 'Frissítette',
  nextDay: 'másnap',
  notAvailable: 'Not available',
  reservationRejectReasons: {
    [ReservationRejectReason.OutsideHours]: 'A foglalás a nyitvatartási időn kívül esik',
    [ReservationRejectReason.Unknown]: 'Hiba történt',
  },
  loggedInGreeting: 'Szia! Miben segíthetünk?',
  loggedOutGreeting: 'Szia! Miben segíthetünk?',
  landingPageTitle: 'Kezeld a foglalásokat egy helyen!',
  landingPageSubtitle: 'A weboldaladról, a Facebook oldaladról, a Facebook Messengerről, a Google keresésről és térképről, a gleblu.ro-ról',
  learnMore: 'Tudj meg többet',
  userHasAccount: 'Van már fiókod?',
  landingPageWaitingTexts: [
    'A személyzet kezelheti a foglalásokat bármilyen számítógépről, laptopról, POS-ről, telefonról vagy táblagépről.',
    'Csak egy webböngészőre van szükséged.',
    'Elfogadhatja vagy visszautasíthatja a foglalásokat a várólistáról,' +
      ' vagy rábízhatod a Gleblu-ra, hogy végezze el a munkát,' +
      ' és automatizálja ezt a folyamatot, hogy időt takarítson meg.',
  ],
  landingPageChatbotTexts: [
    'Ha összekapcsolod a Facebook oldalad a Gleblu chatbotjával,' +
      ' akkor válaszol a vendégeknek a Messengeren,' +
      ' információt nyújt a vendéglátóhelyedről és felveszi a foglalásokat.',
  ],
  errorsResolved: 'Minden hiba megoldódott',
  seatingStartsBeforeOpening: 'Az asztalalok foglalása a nyitás előtt elkezdődik',
  seatingEndsAfterClosing: 'Az asztalalok foglalása a zárás után is folytatódik',
  layoutClosed: 'Terem zárva',
  languages: {
    en: 'Angol',
    hu: 'Magyar',
    ro: 'Román',
  },
  userNotAddedToPlaces: 'Nem vagy hozzáadva egy helyhez sem',
  contactAdministrator: 'Vedd fel a kapcsolatot a rendszergazdával',
  layoutLabel: 'Címke',
  layoutTypeLabel: 'Bent vagy teraszon',
  availability: 'Rendelkezésre állás',
  createLayoutTitle: 'Terem létrehozása',
  stringMaximumLength: (maxLength: number) => `A megengedett maximális hossz: ${maxLength}`,
  pricingDescription: 'Válassza ki az Ön esetének megfelelő előfizetést',
  pricingTitle: {
    [SubscriptionBillingInterval.MONTH]: 'Havi',
    [SubscriptionBillingInterval.YEAR]: 'Évi',
  },
  pricingInterval: {
    [SubscriptionBillingInterval.MONTH]: 'havonta',
    [SubscriptionBillingInterval.YEAR]: 'évente',
  },
  subscriptionState: {
    [SubscriptionState.ACTIVE]: 'Aktív',
    [SubscriptionState.UNDETERMINED]: 'Meghatározatlan',
    [SubscriptionState.TERMINATED]: 'Inaktív',
  },
  currentSubscription: 'Jelenlegi előfizetés:',
  activeUntil: (date: string) => `eddig: ${date}`,
  subscribe: 'Előfizetés',
  resubscribe: 'Újra előfizetni',
  staySubscribed: 'Maradj előfizetve',
  trialDescription: 'Az első 30 nap ingyenes',
  chatbotDescription: [
    'Először kösd össze a Gleblu-t Facebook oldaladdal, majd feliratkozhatsz chatbotunkra.',
    'Chatbotunk három különböző nyelven tud beszélni ügyfeleivel Messengeren keresztül: angolul, románul és magyarul.',
    'Asztalfoglalást is fogadhat Önnek.',
  ],
  processingSubscription: 'Előfizetés feldolgozása...',
  changeInitialPasswordTitle: 'Kezdeti jelszó módosítása',
  changeInitialPasswordExplanation: 'Biztonsági okokból meg kell változtatnia kezdeti jelszavát, mielőtt hozzáférne fiókjához.',
  hoursRequired: `A foglalások kezeléséhez kérjük, először adja meg az étterem nyitvatartási idejét.`,
  hoursSet: `Most, hogy beállította a nyitvatartási időt, engedélyezheti a foglalásokat`,
  defineLayoutDescription: 'Az automatikus foglalásnak ismernie kell a hely elrendezését és asztalait.',
  rejectReservationFailed: 'A foglalás elutasítása nem sikerült',
  acceptReservationFailed: 'A foglalás elfogadása sikertelen',
  reservationConfirmationDescription: 'Bejelentkezés után az összes foglalást megtekintheti a Gleblu alkalmazásban.',
  reservationRejectedSuccessfully: 'Foglalás sikeresen elutasítva',
  reservationAcceptedSuccessfully: 'Foglalás sikeresen elfogadva',
  reservationExpired: 'A foglalás már lejárt',
  reservationNotPending: 'A foglalás már elfogadott vagy elutasított.',
  reviewRequiredPageTitle: 'Ellenőrzés szükséges',
  reviewRequiredPageContent: (placeName) => [
    `A(z) '${placeName}' ellenőrzése jelenleg folyamatban van a Gleblu csapatánál.`,
    `E-mailben értesítünk, amint az ellenőrzés befejeződött, és az oldalad jóváhagyásra került.`,
    `Köszönjük a türelmedet!`,
  ],
  delete: 'Törlés',
  deleteAccountDialogTitle: 'Fiók törlése',
  deleteAccountDialogContent: 'Biztosan törölni szeretnéd a fiókodat?',
  deactivatedAccount: 'Deaktivált fiók',
  deactivatedAccountPageParagraphs: [
    'A fiókodat deaktiváltuk.',
    'A fiók újbóli aktiválásáig nem tudsz bejelentkezni vagy hozzáférni a profilodhoz.',
    `Előfordulhat, hogy a fiók deaktiválásakor egyes funkciók is kikapcsolásra kerültek. ` +
      `A fiók újbóli aktiválása után kérjük, ellenőrizd ezeket a 'Beállítások' menüpontban.`,
  ],
  reactivate: 'Újraaktiválás',
  accountDeletionSucceeded: 'A fiókodat sikeresen töröltük.',
  accountDeletionFailed: 'Nem sikerült törölnünk a fiókodat.',
  deleteYourAccount: 'Fiók törlése',
  deleteYourAccountParagraphs: [
    'Ha már nem szeretnéd használni a szolgáltatásunkat, törölheted a fiókodat.' +
      ' Személyes adataidat egy korlátozott ideig megőrizzük, mielőtt véglegesen törölnénk őket.',
    "Meggondoltad magad? Újraaktiválhatod a fiókodat, ha bejelentkezel, és a 'Újraaktiválás' gombra kattintasz, amennyiben személyes adataid még elérhetők.",
  ],
};

export default hungarianTranslation;
